import React, { Component } from 'react';
import { Col, Container, Row, UncontrolledAlert} from 'reactstrap';
import { ContactCard } from '../cards/ContactCard';
import { FullScreenMenu } from '../menus/FullScreenMenu';
import { ParallaxContainer } from '../parallax/ParallaxContainer';
import { ShojiCarousel } from '../carousel/ShojiCarousel';
import { TitleSubtitleBanner } from '../banners/TitleSubtitleBanner';
import { VideoPlayer } from '../video/VideoPlayer';
import carouselItems from './../../content/carousel.json';
import founders from './../../content/founders.json';

class ShojiApp extends Component {
  videoJsOptions = {
    autoplay: false,
    controls: true,
    sources: [{
      src: '/videos/shoji-kickstarter.mp4',
      type: 'video/mp4'
    }],
    preload: 'auto',
    fluid: true // allow video to fill its parent container (let BS handle sizing)
  }
  
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container className={'px-0 mx-0'} style={{ minHeight: '100%', minWidth: '100%' }}>
        <UncontrolledAlert className="text-center" color="light">
          The Shoji Phone Case has officially launched - shop now on our <strong><a href="https://www.amazon.com/Shoji-iPhone-Case-Protects-Privacy/dp/B079RZBT48/">Amazon page</a></strong>!
        </UncontrolledAlert>
        <FullScreenMenu id="fsMenu" />
        <Container id="homeContainer">
          <Row>
            <Col xl={2} lg={6} md={6} sm={4} xs={6} className='mx-auto mt-5'>
              <img src={'/images/peppermint.shoji.modified.png'} style={{ width: '100%'}}/>
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={8} sm={8} xs={10} className='mx-auto text-center'>
              <h3>Some things are better left <span style={{ fontFamily: 'Cursive', fontWeight: 900 }}>private</span></h3>
            </Col>
          </Row>
          <Row>
            <Col xl={8} className={'mx-auto'}>
              <img src={'/images/shoji-landing.png'} style={{ width: '100%'}}/>
            </Col>
          </Row>
        </Container>
        <TitleSubtitleBanner 
          title={'The Shoji Phone Case'}
          subtitle={'Our Mission'}
          description={'Reclaim your privacy with a Shoji phone case. Stop hackers from spying on you through your camera phone by simply blocking them out. Stay tuned to the official Facebook page for updates on our business and data privacy matters.'}
        />
        <Container className={'mb-5'} id="videoContainer">
          <Row>
            <Col xl={8} lg={8} sm={10} xs={10} className={'mx-auto'}>
              <VideoPlayer { ...this.videoJsOptions } />
            </Col>
          </Row>
        </Container>
        <ParallaxContainer backgroundImageUrl={'/images/shoji-alamo-square-low-res.jpeg'}/>
        <TitleSubtitleBanner 
          id={"whoAreWeContainer"}
          title={'Who are we?'}
          description={"Get to know the team that's bringing you the Shoji phone case!"}
        />
        <Container>
          <Row style={{ minHeight: '500px' }}>
            {founders.map(founder => {
              return (
                <ContactCard 
                  name={founder.name}
                  imagePath={founder.imagePath}
                  role={founder.role}
                  location={founder.hometown}
                  additionalClasses={founder.cssClass}
                  description={founder.description}
                />
              );
            })}
          </Row>
        </Container>
        <ParallaxContainer backgroundImageUrl={'/images/shoji-case-anywhere.jpg'} />
        <ShojiCarousel items={carouselItems} />
      </Container>
    );
  }
}

export default ShojiApp;



// WEBPACK FOOTER //
// ./src/components/app/ShojiApp.js